<template>
  <div class="organization">
    <div class="org-list">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text=" orgList.length == 0? '—— 暂无报名服务单位，请报名活动 ——': '—— 无更多报名服务单位 ——' "
        @load="onLoad"
      >
        <div class="org-item" v-for="(item, i) in orgList" :key="i">
          <div class="overallLeft activityName">{{item.activityName}}</div>
          <div class="org-info">
            <div class="overallLeft info-top">
              <img v-if="item.logo" :src="item.logo" alt="" />
              <img v-else src="../../assets/images/mine/org-item-logo.png" alt=""/>
              <div class="org-tit">
                <div>{{ item.name }}</div>
                <div class=" p1"><span class="p2">联系地址：</span>{{ item.address }}</div>
              </div>
            </div>
            <div class="org-handle">
              <div class="link-info">
                <div>组织单位联系人：<span class="p3">{{ item.linkinfo.linkman }}</span></div>
                <p class="p4">{{ item.linkinfo.phone }}</p>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import {
  getMyInstitution,
  unbindInstitution,
  bindInstitution
} from "@/utils/api/user";
import { signature } from "@/utils/mixin/wx-js-sdk-signature";
export default {
  mixins: [signature],
  data() {
    return {
      //
      loading: false,
      // 数据是否全部加载
      finished: false,
      page: 0,
      pageSize: 10,
      // 报名服务单位列表
      orgList: [],
      // 注册页面扫码功能
      jsApiList: ["scanQRCode"]
    };
  },
  methods: {
    // 加载
    onLoad() {
      // this.page++;
      // this.getMyOrg(this.page === 1);
    },
    // 拉起扫码功能
    pullScan() {
      /* eslint-disable */
      wx.ready(() => {
        wx.scanQRCode({
          needResult: 1,
          scanType: ["qrCode", "barCode"],
          success: (res) => {
            // 绑定报名服务单位
            if (res && res.resultStr) {
              this.$Dialog.confirm({
                  message: "是否绑定该报名服务单位？"
              }).then(() => {
                if(res.resultStr == 'L6E21U'){
                  this.$root.$toast.fail("二维码已失效");
                }else{
                  bindInstitution(res.resultStr).then((rlt) => {
                    if (rlt.success) {
                      this.$root.$toast.success("绑定成功");
                      this.getMyOrg();
                    }
                  });
                }
              }).catch(() => {
                // on cancel
              });
            }
          },
          fail: (err) => {
            const followed = err.errMsg.indexOf(
              "the permission value is offline verifying"
            );
            if (followed > 0) {
              this.$notify({
                type: "danger",
                message: "请检查是否关注该公众号"
              });
              this.$root.$toast.fail({
                message: "获取页面权限失败，请刷新页面后重试！",
                duration: 2000,
                onClose: () => {
                  this.refreshJSToken();
                }
              });
            } else {
              this.$root.$toast.fail({
                message: JSON.stringify(err),
                duration: 2000,
                onClose: () => {
                  this.refreshJSToken();
                }
              });
            }
          }
        });
      });
      /* eslint-disable */
    },
    // 解绑
    unbundle(item) {
      this.$Dialog.confirm({
        message: "确认解绑这个报名服务单位吗？"
      }).then(() => {
        unbindInstitution(item.id).then((res) => {
          if (res.success) {
            this.$root.$toast.success("操作成功");
            this.getMyOrg();
          }
        });
      }).catch(() => {
        // on cancel
      });
    },
    // 获得报名服务单位
    getMyOrg() {
      this.loading = true;
      this.orgList = [];
      getMyInstitution().then((res) => {
        if (res.success && res.data) {
          const loadData = res.data.map((e) => {
            return {
              id: e.id,
              logo: e.logo,
              name: e.name,
              address: e.contactAddress,
              qrCode: e.qrCode,
              linkinfo: {
                linkman: e.personCharge,
                phone: e.contactsTel
              }
            };
          });
          this.orgList.push(...loadData);
          this.loading = false;
          this.finished = true;
        } else {
          this.loading = false;
          this.finished = true;
          this.$root.$toast.fail("暂未绑定报名服务单位，请扫码绑定");
        }
        // this.loading = false;
        // if (this.page * this.pageSize > res.data.total) {
        //   this.finished = true;
        // }
      });
    }
  },
  mounted() {
    this.getMyOrg();
  }
};
</script>
<style lang="scss" scoped>
.organization {
  padding: 20px;
  .org-list {
    .org-item {
      width: 345px;
      height: 170px;
      background-image: url("../../assets/images/mine/my-org-item-back.png");
      background-position: 0 0;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-bottom: 20px;
      padding: 0px 15px;
      overflow: hidden;
      .org-info {
        width: 315px;
        height: 114px;
        background: #F5FCF8;
        border-radius: 10px;
        .info-top{
          height: 72px;
          width: 290px;
          margin: 0 auto;
          border-bottom: 1px solid #ECECF2;
          img {
            width: 48px;
            height: 48px;
            margin-right: 10px;
            border-radius: 24px;
          }
          .org-tit {
            // height: 72px;
            text-align: left;
            // display: flex;
            // flex-direction: column;
            // justify-content: space-between;
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #404046;
            div {
              font-size: 16px;
            }
            .p1 {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 13px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #404046;
            }
            .p2 {
              color: #8E8E94;
            }
          }
        }

      }
      .org-handle {
        width: 290px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        margin-top: 16px;
        .link-info {
          font-size: 14px;
          color: #8E8E94;
          line-height: 20px;
          display: flex;
          text-align: left;
          div {
            margin-right: 10px;
          }
          .p3{
            color: #404046;
          }
          .p4{
            color: #FF7856;
          }
        }
      }
    }
  }
}
.activityName{
  height: 42px;
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: 400;
  color: #FFFFFF;
}
</style>
